import React from "react";

/**
 * StyledSection
 * Reusable component that provides a styled container similar to "Your Hand"
 * Can be used for indexes, stocks, or any other card sections
 */
const StyledSection = ({
  title,
  icon = "📊",
  children,
  emptyMessage = "No items to display",
  isEmpty = false,
  containerStyle = {},
  isOverlay = false,
  overlayStyle = {}
}) => {
  const renderLabel = () => (
    <div className="styled-section-label">
      <span>{icon}</span>
      <span className="styled-section-label-text">
        {title}
      </span>
    </div>
  );

  const content = (
    <div 
      className={`styled-section-container ${isEmpty ? 'empty' : ''}`}
      style={containerStyle}
    >
      {renderLabel()}
      {isEmpty ? (
        <span className="styled-section-empty-message">
          {emptyMessage}
        </span>
      ) : (
        children
      )}
    </div>
  );

  // If overlay mode, wrap in fixed positioning container
  if (isOverlay) {
    return (
      <div className="styled-section-overlay" style={overlayStyle}>
        <div className="styled-section-overlay-content">
          {content}
        </div>
      </div>
    );
  }

  return content;
};

export default StyledSection;

